import Layout from '../components/layout';
import { useRouter } from 'next/router';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useCallback, useEffect, useState } from 'react';
import dynamic from 'next/dynamic'
const FirstStep = dynamic(() => import('../components/firstStep'))
import SecondStep from '../components/secondStep';
import ThirdStep from '../components/thirdStep';
import styles from '../styles/configuration.module.scss';
import { useTranslation } from 'react-i18next';

export default function Configuration() {
  const router = useRouter()
  const { t } = useTranslation('configuration');
  const initialConfigs = {
    infrastructure: {
      storage: {
        type: 1,
        ssd: {
          nodes: 3,
          size: 1024
        },
        hdd: {
          nodes: 3,
          size: 1024
        },
        isExternal: false,
        // dedicated: false
      },
      compute: {
        computeNodes: 3,
        cpu: 12,
        ram: 128,
        gpu: 0
      }
    },
    compute: {
      ssd: 0,
      hdd: 0,
      cpu: 0,
      ram: 0
    },
    equipment: {
      dedicated: true,
      data: 'cisco',
      management: 'cisco'
    },
    networking: {
      bandwidth: "100 Mbps",
      ipv4: "/28",
      isAnonymus: false,
      degree: 'min'
    },
    storage: {
      ssd: {
        s3: 0,
        iscsi: 0
      },
      hdd: {
        s3: 0,
        iscsi: 0
      }
    },
    code: {
      ssd: 0,
      isCheck: false
    },
    disk: {
      users: 0,
      space: 0,
      isCheck: false
    },
    artifactory: {
      ssd: 0,
      isCheck: false
    },
    openshift: {
      cpu: 8,
      hddSpace: 0,
      nodes: 3,
      ram: 32,
      space: 0,
      blockSsd: 0,
      blockHdd: 0,
      filesystem: 0,
      s3: 0,
      fs: 0,
      isCheck: false,
      degree: "min",
    },
    compliance: false,
    migrator: false,
    devops: false,
    projects: false
  };

  const [currentStepNumber, setCurrentStepNumber] = useState(0);
  const [configs, setConfigs] = useState(initialConfigs);
  const [response, setResponse] = useState(undefined);
  const [pdf, setPdf] = useState(null);

  useEffect(() => {
    if (response && pdf && currentStepNumber === 2) {
      pdf.save('icdc-configuration.pdf');
      setPdf(null);
    }
  }, [response, pdf, currentStepNumber]);

  return (
      <Layout title={t('titleConfigure')} lang={router.locale} route={router.route} isHeader>
        <main className={styles.main}>
          <FirstStep className={currentStepNumber === 0 ? '' : styles.hidden}
                    changeStep={useCallback(value => setCurrentStepNumber(prevState => prevState + value))}
                    setConfig={useCallback(configs => setConfigs(configs), [])}
                    intialConfigs={configs}
                    setPdf={(newPdf) => setPdf(newPdf)} />
          <SecondStep className={currentStepNumber === 1 ? '' : styles.hidden}
                    changeStep={useCallback((value, isSuccess) => { setCurrentStepNumber(prevState => prevState + value); setResponse(isSuccess); })}
                    configs={configs}
                    language={router.locale} />
          <ThirdStep className={currentStepNumber === 2 ? '' : styles.hidden}
                    changeStep={useCallback(value => setCurrentStepNumber(prevState => prevState + value))}
                    response={response}
                    pdf={pdf}
                    setPdf={newPdf => setPdf(newPdf)} />
        </main>
      </Layout>
  )
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['common', 'configuration']),
  },
});
